//@flow
import * as _ from 'lodash';
import { urlsConstants } from '../constants/url.constant';
import { defaultService } from './defaultService';

export const mapaProdutosService = {
  doGet,
  doSave,
  findByFiltro,
  doDelete,
  findMapaPedido,
};

function findByFiltro(options: Options, filter: any): Promise<any> {
  const params = [];
  if (_.get(filter, 'pontoAtendimentoId')) {
    params.push(
      `pontoAtendimentoId=${encodeURIComponent(filter.pontoAtendimentoId)}`
    );
  }
  if (_.get(filter, 'cliente')) {
    params.push(
      `codigoCliente=${encodeURIComponent(filter.cliente.codigoCliente)}`
    );
  }

  if (_.get(options, 'page') !== undefined) {
    params.push(`page=${options.page - 1}`);
  }
  const queryString = params.length ? `?${params.join('&')}` : '';
  return defaultService.doGet(
    `${urlsConstants.API_MAPA_PRODUTOS}filtro${queryString}`,
    options
  );
}

function doDelete(id) {
  return defaultService.doDelete(`${urlsConstants.API_MAPA_PRODUTOS}${id}`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.API_MAPA_PRODUTOS}${id}`);
}

function doSave(pa) {
  return defaultService.doSave(urlsConstants.API_MAPA_PRODUTOS, pa);
}

function findMapaPedido(pa, produtoIds) {
  const ids = (produtoIds || []).filter(Boolean);
  const queryString = ids.length
    ? `?${ids.map((id) => `produtoId=${encodeURIComponent(id)}`).join('&')}`
    : '';

  return defaultService.doGet(
    `${urlsConstants.API_MAPA_PRODUTOS}findByPontoAtendimentoId/${pa}${queryString}`
  );
}
